<template>
  <f7-page name="config">
    <f7-navbar>
			<f7-nav-left>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <div class="title">
        환경설정
      </div>
			<f7-nav-right>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="right"></f7-link>
      </f7-nav-right>
    </f7-navbar>
    <!--
		<f7-block-title v-if="isUser()">사용자 계정</f7-block-title>
		<div class="list" v-if="isUser()">
			<ul>
				<li>					
					<a class="item-link panel-close item-content" href="/student-modify" data-view=".view-main" data-clear-previous-history="true">
						<div class="item-inner">
							<div class="item-title">회원정보 수정</div>
						</div>
					</a>
				</li>
			</ul>
		</div>
		-->
		<f7-block-title>프로그램 환경설정</f7-block-title>
		<div class="list">
			<ul>
				<li>
					<div class="item-content">
						<div class="item-inner">
							<div class="item-title">프로그램 업데이트 확인</div>
						</div>
					</div>
				</li>
			</ul>
		</div>
  </f7-page>
</template>

<script>
import MODULE from '../../js/common/module';
import Vue from 'vue';
import PAGES from '../../js/pages';
import CONST from '../../js/common/constant';
import API from '../../js/common/api';
import AUTH from '../../js/common/auth';

export default {
  data() {
    return {
      
    }
  },
  mounted() {
		
  },
  methods: {
    isUser() {
			return !AUTH.isGuest();
		},
  }
}

</script>